var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCream(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 1C7.707 1 1 7.724 1 16s6.707 15 15 15 15-6.707 15-15c0-8.276-6.724-15-15-15zm1.207 15.707 5.258 5.258a.994.994 0 0 1-.103 1.5A9.443 9.443 0 0 1 16.5 25.5c-5.603 0-10.086-4.862-9.43-10.586.482-4.397 4.05-7.931 8.465-8.362a9.53 9.53 0 0 1 6.879 2c.465.362.483 1.051.069 1.465l-5.276 5.276a.99.99 0 0 0 0 1.414z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCream);
export default __webpack_public_path__ + "static/media/CREAM.3cf0bd3c2be73ef504ea7604369331d9.svg";
export { ForwardRef as ReactComponent };